/* eslint-disable max-len */
import api from '../../../services/api';

/**
 * @param {string} profileId
 */
const API_URL = (profileId) => `/api/v1/manager/bidProfile/${profileId}/report`;

/**
 * @param {string} profileId
 * @param {EmployeePreferencesReport.IEmployeeReportFilters} filters
 * @param {EmployeePreferencesReport.IPagination} pagination
 * @param {EmployeePreferencesReport.ISortParameters} sort
 * @returns {Promise<ApiManager.EmployeesSelectionResponse>}
 */
export const EmployeesSelection = (profileId, filters, pagination, sort) => api.post(`${API_URL(profileId)}/employeesSelection`, {
    searchQuery: filters.search,
    employeeIdsFilter: filters.selectedEmployees,
    dataviewColumnsFilter: filters.dataviewColumnsFilter,
    pageIndex: pagination.pageNumber - 1,
    pageSize: pagination.pageSize,
    sortColumn: sort.sortColumn,
    sortOrder: sort.sortOrder,
});

/**
 * @param {string} profileId
 * @param {string[]} employeeIds
 * @param {string[]} dataviewKeyAlias
 * @param {string} searchQuery
 */
export const DownloadEmployeeSelectionsCsv = (profileId, employeeIds, dataviewKeyAlias, searchQuery) => api.post(`${API_URL(profileId)}/employeesSelection/CSV`, { employeeIds, dataviewKeyAlias, searchQuery });

/**
 * @param {string} profileId
 * @param {string} searchQuery
 * @param {number} pageIndex
 * @param {number} pageSize
 * @returns {Promise<ApiManager.GetUnawardedShiftlinesResponse>}
 */
export const getUnawardedShiftlines = (profileId, searchQuery, pageIndex, pageSize) =>
    api.post(`${API_URL(profileId)}/shiftlines/unawarded`, { searchQuery, pageIndex, pageSize });

/**
 * @param {string} profileId
 * @param {string} searchQuery
 */
export const DownloadUnawardedShiftlinesCsv = (profileId, searchQuery) => api.post(`${API_URL(profileId)}/shiftlines/unawarded/CSV`, { searchQuery });

/**
 * @param {string} profileId
 * @param {{
 *  employeeIds: string[]
 *  searchQuery: string
 *  pageIndex: number
 *  pageSize: number
 *  sortColumn: number
 *  isSortAscending: boolean
 *  dataviewKeyAlias: string[]
 * }} searchParams
 * @returns {Promise<ApiEmployee.GetEmployeeBidResultResponse>}
 */
export const getEmployeeBidResult = (profileId, searchParams) =>
    api.post(`${API_URL(profileId)}/employeeBidResult`, searchParams);

/**
 * @param {string} profileId
 * @param {string[]} employeeIds
 * @param {string[]} dataviewKeyAlias
 * @param {string} searchQuery
 */
export const DownloadEmployeeBidResult = (profileId, employeeIds, dataviewKeyAlias, searchQuery) => api.post(`${API_URL(profileId)}/employeeBidResult/CSV`, { employeeIds, dataviewKeyAlias, searchQuery });

/**
 * @param {string} profileId
 * @param {string[]} employeeIds
 * @param {string[]} dataviewKeyAlias
 * @param {string} searchQuery
 */
export const DownloadEmployeeRank = (profileId, employeeIds, dataviewKeyAlias, searchQuery) => api.post(`${API_URL(profileId)}/employeesRank/CSV`, { employeeIds, dataviewKeyAlias, searchQuery });
